import { reportClient } from '../../api/clients';
import fetchPipelineSummaryFilters from './get-pipeline-summary-filters/get-pipeline-summary-filters-service';
import fetchPipelineSummary from './get-pipeline-summary/get-pipeline-summary-service';

const pipelineSummaryService = {
  getPipelineSummary: fetchPipelineSummary(reportClient),
  getPipelineSummaryFilters: fetchPipelineSummaryFilters(reportClient),
};

export default pipelineSummaryService;
